import React from 'react';
import {
  LabelContainer,
  NavigationButtons,
} from './BottomNavigationBar.styled';
import { Home } from '../../common/icons/Home';
import { Body7 } from '../../common/typography';
import { Assessment } from '../../common/icons/Assessment';
import { ClickAndPress } from '../../common/icons/ClickAndPress';
import { Sheet } from '../../common/icons/Sheet';
import { Learning } from '../../common/icons/Learning';
import { useNavigate } from 'react-router-dom';

export function BottomNavigationBar () {
  const navigate = useNavigate();
  return (
    <>
      <NavigationButtons onClick={() => navigate('dashboard')}>
        <Home />
        <LabelContainer>
          <Body7 color="dimGray">Dashboard</Body7>
        </LabelContainer>
      </NavigationButtons>
      <NavigationButtons onClick={() => navigate('assessments')}>
        <Assessment />
        <Body7 color="dimGray">
          <LabelContainer>Assessment</LabelContainer>
        </Body7>
      </NavigationButtons>
      <NavigationButtons onClick={() => navigate('management')}>
        <ClickAndPress />
        <Body7 color="dimGray">
          <LabelContainer>
            <LabelContainer>myActions</LabelContainer>
          </LabelContainer>
        </Body7>
      </NavigationButtons>
      <NavigationButtons onClick={() => navigate('newsfeed')}>
        <Sheet />
        <Body7 color="dimGray">
          <LabelContainer>Newsfeed</LabelContainer>
        </Body7>
      </NavigationButtons>
      <NavigationButtons onClick={() => navigate('learning')}>
        <Learning />
        <Body7 color="dimGray">
          <LabelContainer>Learning</LabelContainer>
        </Body7>
      </NavigationButtons>
    </>
  );
}
